import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataStateChangeEvent, GridDataResult} from '@progress/kendo-angular-grid';
import {JwtService} from 'mclane-webauth-lib';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {ConfirmationService} from '~/app/core/common/services/confirmation.service';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {ScheduleService} from '~/app/core/common/services/schedule.service';
import {take} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, AfterViewInit {
    loading: any;
    gridData: GridDataResult;
    title: string;
    message: string;
    buttons: any;
    public wholeUnit = 0;
    public partialUnit = 0;
    public decimalValue = 0;
    buttonDefinitions: string[];
    public inventoryItem: any;
    public partialDecimal: any;
    public packSize: any | number;
    @Input()
    public opened = false;
    @Output()
    public closed = new EventEmitter<string>();
    public selection: string[] = [];

    public columns: any[] = [{field: 'trackingId', title: 'PO Number', width: '160', filterable: true},
        {field: 'itemNumber', title: 'Item Number', width: '240', filterable: true},
        {field: 'description', title: 'Description', width: '150', filterable: false},
        {field: 'price', title: 'Price', width: '165', media: '(min-width: 768px)', format: '{0:c}'},
        {field: 'quantity', title: 'Quantity', width: '150', media: '(min-width: 768px)'},
        {field: 'totalPrice', title: 'Total Cost', width: '100', format: '{0:c}'},
        {field: 'reason', title: 'Reason', width: '100'}];
    processRunning: any;
    confirmationMessage: any;
    isDisabled: boolean;

    constructor(private configurationService: ConfigurationService, private _storeListService: StoreListService,
                private confirmationService: ConfirmationService,
                private storeListService: StoreListService, private _scheduleService: ScheduleService,
                private _jwtService: JwtService,
                public dialogHelper: DialogHelperComponent) {
    }

    async ngAfterViewInit() {
        if (this._jwtService.roles !== undefined) {
            if (this.confirmationService.confirmationItemList !== undefined) {
                this.gridData = {
                    data: this.confirmationService.confirmationItemList,
                    total: this.confirmationService.confirmationItemList.length
                };
                if (this.confirmationService.confirmationItemList.length < 1) {
                    this.processRunning = false;
                    this.isDisabled = true;
                }
            }
        }
    }

    async ngOnInit() {
    }

    public open(type: string,
                title: string): Promise<any> {

        this.title = title;
        this.message = '';
        this.opened = true;
        return this.closed.asObservable()
            .pipe(take(1))
            .toPromise();
    }

    public close() {
        this.opened = false;
        this.closed.emit();
    }

    dataStateChange($event: DataStateChangeEvent) {
    }

    acknowledge(dataItem) {
        this.processRunning = true;
        this.isDisabled = true;
        this.loading = true;
        this.confirmationService.acknowledgeItems(
            String(this._storeListService.pickedCustomerId)).toPromise().then((data: any) => {
            this.processRunning = false;
        }).catch((error) => {
            this.confirmationMessage = 'Error trying to acknowledge items';
            throwError(error);
        }).then(async () => {
            this.processRunning = false;
            this.isDisabled = false;
            this.loading = false;
            const pickedCustomerId = await this.storeListService.pickedCustomerIdVerify();
            await this._scheduleService.getOrderSchedules(String(pickedCustomerId));
            await this._scheduleService.updateCalendarEvents();
            await this.confirmationService.getStoreConfirmation();
            this.close();
        });
    }
}
